import { NotFoundContent } from 'components/ErrorStates/NotFoundErrorState/NotFoundErrorState';
import { GET_COMPANY } from 'components/NavBar/queries';
import { usePlutoApiQuery } from 'hooks/useQuery/plutoApi';
import { Outlet, useParams } from 'react-router';

export const CompanyPageWrapper = () => {
  const { company } = useParams();

  const { data, loading } = usePlutoApiQuery(GET_COMPANY, {
    skip: !company,
    variables: { id: company },
  });

  if (company && !loading && !data?.company) {
    return <NotFoundContent />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};
